export enum EmployeeRole {
  MINIJOBBER = 'Minijobber',
  WERKSTUDENT = 'Werkstudenten',
  VOLLZEIT = 'Vollzeit-MA',
  TEILZEIT = 'Teilzeit-MA',
  TESTER = 'Tester',
}
